import React, { useEffect, useState } from "react";
import SliderCard from "./SliderCard";
import { Box, Link, Typography } from "@mui/material";
import Flickity from "react-flickity-component";
import "flickity/css/flickity.css";
import "./sliderStyle.css";
import { useTheme } from "@mui/material/styles";
import HighFive from "../images/img-high_five.png"
import { postToHubSpot } from "../api/APIs";
let cards = [];
const Slider = ({ optimalPlans, setNotAvailable, setAvailable }) => {
  const [billEnergyCharge, setBillEnergyCharge] = useState();
  const [savingPercent, setSavingPercent] = useState();
  const theme = useTheme();
  useEffect(() => {
    if (optimalPlans.plans.length === 0) {
      setAvailable(false);
      setNotAvailable(true);
    }
  }, [optimalPlans]);

  useEffect(() => {
    let _billEnergyCharge = localStorage.getItem('BillEnergyCharge');
    if (_billEnergyCharge) {
      setBillEnergyCharge(_billEnergyCharge)
    }
  }, [])

  useEffect(()=>{
    if (billEnergyCharge && optimalPlans && optimalPlans.plans && optimalPlans.plans[0] && optimalPlans.plans[0][0]  && optimalPlans.plans[0][0].ENERGYCHARGE) {
      let rateDiff = parseFloat(billEnergyCharge) - (parseFloat(optimalPlans.plans[0][0].ENERGYCHARGE)* 100);
      setSavingPercent(Math.round((rateDiff / billEnergyCharge) * 100))
    }

  },[billEnergyCharge, optimalPlans])

  useEffect(()=>{
    handleSendForm(false);
  },[])

  const handleSendForm = (flag) =>{
    const userInfo =  localStorage.getItem("userInfo");
    const status = flag ? "Enrollment Click" : "Save No Enrollment";
    if (userInfo) {
      const user = JSON.parse(userInfo);
      postToHubSpot(user.firstName, user.lastName, user.email, status).then((res)=>{
        console.log(res);
      })
    }
  }

  return (
    <Box sx={{ display: "flex", flexDirection: { xs: "column", lg: "row" } }}>
      <Box
        width={{ xs: "100%", lg: "40%" }}
        mb={{ xs: "10%", lg: "0" }}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >

        <Box
          sx={{
            marginTop: { sm: "20px" },
            width: { sm: "100%", lg: "80%" }
          }}
        >
          <img src={HighFive} style={{ borderRadius: 30 }} width={"100%"} />
        </Box>

        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: {
              xs: "5vw",
              sm: "5vw",
              md: "5vw",
              lg: "3vw",
            },
            fontWeight: {
              xs: "500",
              sm: "500",
              md: "500",
              lg: "900",
            },
            color: "#00B49D",
            textTransform: "uppercase",
          }}
        // align="center"
        >
          You can save on electricity with bkv energy
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: "5.5vw",
              sm: "5.5vw",
              md: "5vw",
              lg: "40px",
            },
            color: theme.palette.primary.main,
            whiteSpace: "wrap",
            // marginBottom: { xs: "10%", sm: "10%", md: "6%", lg: "2%" },
          }}
          // align="center"
          variant="body2"
        // padding={{ xs: "0 10%", sm: "0 10%", md: "0 10%", lg: "0 5%" }}
        >
          {/* These electricity plans can help you save! */}
          Switch and save up to {savingPercent}% on electricity!
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
          }}
          variant="body1"
        >
          Based on the analysis of your uploaded documents, we've found these
          energy plans could lead to lower electricity bills.
        </Typography>
        <ul style={{paddingLeft:'1.2rem'}}>
          {billEnergyCharge && <li>
            <Typography 
                sx={{
                  fontSize: "16px",
                  fontWeight:'800'
                }}
                variant="body1">
              Your Current Energy Charge: {billEnergyCharge} cents
            </Typography>
          </li>}
         {optimalPlans.plans.length !== 0 && <li>
            <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight:'800'
                }}
                variant="body1">
              BKV Energy's Energy Charge: {(parseFloat(optimalPlans.plans[0][0].ENERGYCHARGE) * 100).toFixed(2)} cents
            </Typography>
          </li>}
        </ul>
      </Box>
      <Box width={{ xs: "100%", lg: "60%" }}>
        {optimalPlans.plans.length !== 0 && optimalPlans.plans.length > 2 && <Flickity>
          {optimalPlans.plans.map((item) => {
            return <SliderCard item={item} zipcode={optimalPlans.zipCode} />;
          })}
        </Flickity>}

        {optimalPlans.plans.length !== 0 && optimalPlans.plans.length <= 2 &&
          optimalPlans.plans.map((item) => {
            return <SliderCard item={item} zipcode={optimalPlans.zipCode} />;
          })}
      </Box>
    </Box>
  );
};

export default Slider;
